/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Contact_AsideInputs */

const en_platform_contact_aside = /** @type {(inputs: Platform_Contact_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This reaches the people who build the software. Your own coach is on their own page.`)
};

const pl_platform_contact_aside = /** @type {(inputs: Platform_Contact_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To kontakt do osób, które tworzą to oprogramowanie. Twój trener ma własną stronę.`)
};

/**
* | output |
* | --- |
* | "This reaches the people who build the software. Your own coach is on their own page." |
*
* @param {Platform_Contact_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_contact_aside = /** @type {((inputs?: Platform_Contact_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Contact_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_contact_aside(inputs)
	return en_platform_contact_aside(inputs)
});